import eHealth_Brochure from '../assets/PDF/eHealth Brochure.pdf'
import UNIFIED_E_HEALTH from '../assets/UNIFIED E-HEALTH.jpg';
import UNIFIED_E_HEALTH_2 from '../assets/UNIFIED E-HEALTH_2.jpg';
import eHealth_Presentation from '../assets/PDF/eHealth Presentation.swf';
import ehealth from '../assets/ehealth.png'
//---------------------
import HOSPITAL_MANAGEMENT from '../assets/HOSPITAL MANAGEMENT.jpg';
import HOSPITAL_MANAGEMENT_2 from '../assets/HOSPITAL_MANAGEMENT_2.jpg';
//=============================
import POLYCLINIC_MANAGEMENT from '../assets/POLYCLINIC MANAGEMENT.jpg';
//------------------------------
import ENTERPRISE_IMAGING from '../assets/ENTERPRISE IMAGING.jpg';
import ENTERPRISE_IMAGING_2 from '../assets/ENTERPRISE_IMAGING_2.jpg';
import Worksrpace_VNA_Brochure from '../assets/PDF/Worksrpace_VNA_Brochure.pdf' ;
import VNA_IHE_Integration_Statement from '../assets/PDF/VNA_IHE_Integration_Statement.pdf' ;
import DICOM_Conformance_Statement from '../assets/PDF/DICOM_Conformance_Statement.pdf' ;
import Workspace_VNA_Presentation from '../assets/PDF/Workspace_VNA_Presentation.swf' ;
import RIS_PACS_workflow_Animation from '../assets/PDF/pacs_ris_workflow.swf' ;
import RIS_PACS_Workflow_Presentation from '../assets/PDF/pacs_ris_components.swf' ;
import workspace from '../assets/workspace.jpg' ;
//==================
import RADIOLOGY_MANAGEMENT from '../assets/RADIOLOGY MANAGEMENT.jpg';
import rad_unifiedrad2021 from '../assets/rad_unifiedrad2021.jpg';
//----------------------
import LAB_MANAGEMENT from '../assets/LAB MANAGEMENT.jpg';
import LAB_MANAGEMENT_2 from '../assets/LAB_MANAGEMENT_2.jpg';
import MiClinic_Presentation from '../assets/PDF/MiClinic_Presentation.pdf';
import IHE_Integration_Statement from '../assets/PDF/IHE_Integration_Statement.pdf';
import miclinic_lab_modules from '../assets/miclinic-lab-modules.jpg';
//-------------------------
import CARDIOLOGY from '../assets/CARDIOLOGY.jpg';
//--------------------------
import GASTROENTROLOGY from '../assets/GASTROENTROLOGY.jpg';
import GASTROENTROLOGY_2 from '../assets/GASTROENTROLOGY_2.jpg';
import conn_video from '../assets/conn_video.jpg'
import Endo_Brochure from '../assets/PDF/Endo_Brochure.pdf';
import Endo_Non_DICOM_Connectivity from '../assets/PDF/Endo_Non_DICOM_Connectivity.pdf';
import DICOM_Conformance_Statement_2 from '../assets/PDF/DICOM_Conformance_Statement_2.pdf';
//================================
import DERMATOLOGY from '../assets/DERMATOLOGY.jpg';
import DERMATOLOGY_2 from '../assets/DERMATOLOGY_2.jpg';
import miclinic_Derma from '../assets/miclinic-Derma.jpg';
import MiClinic_Brochure from '../assets/PDF/MiClinic_Brochure.pdf';
import MiClinic_Presentation_2 from '../assets/PDF/MiClinic_Presentation_2.swf';
import IHE_Integration_Statement_2 from '../assets/PDF/IHE_Integration_Statement_2.pdf';
import DICOM_Conformance_Statement_3 from '../assets/PDF/DICOM_Conformance_Statement_3.pdf';
//----------------------------
import DENTAL_IMAGING from '../assets/DENTAL IMAGING.jpg';
import DENTAL_IMAGING_2 from '../assets/DENTAL_IMAGING_2.jpg';
//----------------------------
import Homecare_Presentation from '../assets/PDF/Homecare_Presentation.pdf'
import HOME_CARE from '../assets/HOME CARE.jpg';
import Home_Care_2 from '../assets/Home_Care_2.jpg';
//-----------------------
import TELE_MEDICINCE from '../assets/TELE MEDICINCE.jpg';
import TELE_MEDICINCE_2 from '../assets/TELE_MEDICINCE_2.jpg';
import Telemedicine_Presentation from '../assets/PDF/Telemedicine_Presentation.pdf' ;
//----------------------
import MOBILE_HEALTH from '../assets/MOBILE HEALTH.jpg';
import MOBILE_HEALTH_2 from '../assets/MOBILE_HEALTH_2.jpg';
import Product_Presentation from '../assets/PDF/Product_Presentation.pdf'
import healthwalletworkflow from '../assets/healthwalletworkflow.jpg'
//=====================
import FINANCIAL_MANAGEMENT from '../assets/FINANCIAL MANAGEMENT.jpg';
import FINANCIAL_MANAGEMENT_2 from '../assets/FINANCIAL_MANAGEMENT_2.jpg';
//-----------------------
import INVENTORY_MANAGEMENT from '../assets/INVENTORY MANAGEMENT.jpg';
import INVENTORY_MANAGEMENT_2 from '../assets/INVENTORY_MANAGEMENT_2.jpg';
//=======================
import HUMAN_CAPITAL_MANAGEMENT from '../assets/HUMAN CAPITAL MANAGEMENT.jpg';
import HUMAN_CAPITAL_MANAGEMENT_2 from '../assets/HUMAN_CAPITAL_MANAGEMENT_2.jpg';
import MiERP_Presentation from '../assets/PDF/MiERP_Presentation.swf'
import MiERP_HR_Brochure_Arabic from '../assets/PDF/MiERP_HR_Brochure_(Arabic).pdf'
//============================
import EHR_HMIS from '../assets/New folder/2.jpg';
import EHR_HMIS_2 from '../assets/EHR_HMIS_2.jpg';
import MiClinic_EHR_Brochure from '../assets/PDF/MiClinic_EHR_Brochure.pdf' ;
import MiClinic_EHR_Presentation from '../assets/PDF/MiClinic_EHR_Presentation.pdf' ; 
import miclinic_ehr_modules from '../assets/miclinic_ehr_modules.jpg'
//=================================
import EMR from '../assets/New folder/3.jpg';
import EMR_2 from '../assets/EMR_2.jpg';
import MiClinic_EMR_Brochure from '../assets/PDF/MiClinic_EMR_Brochure.pdf';
import MiClinic_EMR_Presentation from '../assets/PDF/MiClinic_EMR_Presentation.pdf';
import miclinic_emr_en from '../assets/miclinic_emr_en.jpg'
//------------------------------
import RIS from '../assets/New folder/4.jpg';
import RIS_2 from '../assets/RIS_2.jpg';
import MiClinic_RIS_Brochure from '../assets/PDF/MiClinic_RIS_Brochure.pdf';
import MiClinic_RIS_Presentation from '../assets/PDF/MiClinic_RIS_Presentation.pdf';
import RIS_PACS_workflow_Animation_2 from '../assets/PDF/RIS_PACS_workflow_Animation.swf';
import RIS_PACS_Workflow_Presentation_2 from '../assets/PDF/RIS_PACS_Workflow_Presentation.swf';
import miris_modules from '../assets/miris-modules.jpg';
//---------------------------
import LIS from '../assets/New folder/5.jpg';
import LIS_2 from '../assets/LIS_2.jpg';
//---------------
import PACS from '../assets/New folder/2-2.jpg';
import PACS_2 from '../assets/PACS_2.jpg';
import mi_ws_pacs from '../assets/mi-ws-pacs.jpg'
import Worksrpace_PACS_Brochure from '../assets/PDF/Worksrpace_PACS_Brochure.pdf';
import PACS_IHE_Integration_Statement from '../assets/PDF/PACS_IHE_Integration_Statement.pdf';
//----------------------------
import PACS_Viewer from '../assets/New folder/2-3.jpg';
import PACS_Viewer_2 from '../assets/PACS_Viewer_2.jpg';
import MultiView_Brochure from '../assets/PDF/MultiView_Brochure.pdf';
import MultiView_Presentation from '../assets/PDF/MultiView_Presentation.swf';
//------------------
import Teleradiology from '../assets/New folder/2-4.jpg';
import Teleradiology_2 from '../assets/Teleradiology_2.jpg';
import telerad3 from '../assets/telerad3.jpg';
import Teleradiology_Brochure from '../assets/PDF/Teleradiology_Brochure.pdf';
import Workspace_VNA_PACS_Brochure from '../assets/PDF/Workspace_VNA_PACS_Brochure.pdf';
import MiRIS_RIS_Brochure from '../assets/PDF/MiRIS_RIS_Brochure.pdf';
//----------------------
import Disc_Publisher from '../assets/New folder/2-5.gif';
import Disc_Publisher_2 from '../assets/Disc_Publisher_2.jpg';
import mipublisher_miprint from '../assets/mipublisher_miprint.jpg';
import Brochure from '../assets/PDF/Brochure.pdf';
import MiPublisher_Pro from '../assets/PDF/MiPublisher_Pro.pdf';
//-------------------------
import DICOM_Print from '../assets/New folder/DICOM_Print.jpg';
import DICOM_Print_2 from '../assets/DICOM_Print_2.jpg';
import Brochure_2 from '../assets/PDF/Brochure_2.pdf';
//---------------------
import Financials from '../assets/New folder/3-2.jpg';
import Financials_2 from '../assets/FINANCIAL_MANAGEMENT_2.jpg';
//--------------------
import CRM from '../assets/CRM.jpg';
import CRM_2 from '../assets/New folder/3-5.jpg';
import MiCRM_Brochure from '../assets/PDF/MiCRM_Brochure.pdf';
//---------------------------------
import Business_Intelligence from '../assets/Business_Intelligence.jpg';
import Business_Intelligence_2 from '../assets/Business_Intelligence_2.jpeg';
import MiAnalytics_Brochure from '../assets/PDF/MiAnalytics_Brochure.pdf'
//--------------------
import Integration from '../assets/Integration_1.jpg';
import Integration_2 from '../assets/Integration_2.jpg';
import HL7_Conformance_Statement from '../assets/PDF/HL7_Conformance_Statement.pdf';
//---------------------------
import DICOM_Viewer from '../assets/DICOM_Viewer.jpg';
//--------------
import {
    text_1,
    text_2,
    text_3,
    text_4,
    text_5,
    text_6,
    text_7,
    text_8,
    text_9,
    text_10,
    text_11,
    text_12,
    text_13,
    text_14,
    text_15,
    text_16,
    text_17,
    text_18,
    text_19,
    text_20,
    text_21,
    text_22,
    text_23,
    text_24,
    text_25,
    text_26,
    text_27,
    text_28,
    text_29,
    text_30,
    text_31,
    text_32,
    text_33,
    text_34,
    text_35,
    text_36,
    text_37,
    text_38,
    text_39,
    text_40,
    text_41,
    text_42,
    text_43,
    text_44,
    text_45,
    text_46,
    text_47,
    text_48,
    text_49,
    text_50,
    text_51,
    text_52,
    text_53,
} from './text';


export const products = [
    {   
        id:1,
        productTitle : 'Modular Enterprise Healthcare Platform',
        img_1 : UNIFIED_E_HEALTH,
        img_2 : UNIFIED_E_HEALTH_2,
        title_1 : 'Why MILLENSYS Unified eHealth ?',
        sub_title_1 : 'The unified Information Management platform for a total management of hospitals and healthcare operation.',
        content_1 :text_1,

        title_2 : 'Create and deliver a value for all stakeholders',
        sub_title_2 : 'Achieve operation excellence in the healthcare enterprise with the unified management platform.',
        content_2 :text_2,
        links :[
            {link : eHealth_Brochure ,linkName : 'eHealth Brochure'},
            {link : eHealth_Presentation ,linkName : 'eHealth Presentation'},
        ],
        vSrc :"https://www.youtube.com/embed/gTfiNyUNyLU",
        vTitle :"MILLENSYS hospital management software platform",
        vHeader :'MiClinic Unified eHealth' ,
        vContent :'Achieve operational excellence in healthcare management',
        fContent :`All-in-One Platform for best outcomes of healthcare management and patients care.`,
        fTitle : `MiClinic Unified eHealth` ,
        fImg  : ehealth,
    },
    {   
        id:2,
        productTitle : 'HOSPITAL MANAGEMENT',
        img_1 : HOSPITAL_MANAGEMENT,
        img_2 : HOSPITAL_MANAGEMENT_2,
        title_1 : 'MIlLENSYS, Unified Hospital Management Platform',
        sub_title_1 : 'A powerful and expandable software solution to manage a hospital or group of hospitals.',
        content_1 :text_3,

        title_2 : 'The platform includes',
        sub_title_2 : 'powerful financial management software ( ERP ) components to manage billing for patients and physicians ,',
        content_2 :text_4,
        vSrc :"https://www.youtube.com/embed/gTfiNyUNyLU",
        vTitle :"MILLENSYS hospital management software platform" ,
        vHeader :'MiClinic Unified eHealth' ,
        vContent :'Achieve operational excellence in healthcare management',
    },
    {   
        id:3,
        productTitle : 'POLYCLINIC MANAGEMENT',
        img_1 : POLYCLINIC_MANAGEMENT,
        title_1 : 'MIlLENSYS, Unified Clinical Management Platform',
        sub_title_1 : 'The Unified Solution to manage a policlinic or outpatient OPD department .',
        content_1 :" An All-in-one solution to schedule patients, manage admission , acquire images from modalities, archive patient studies , handle patient medical reporting , manage billing, claims and inventory items plus a full back-end financial management system including ERP and HR",
        vSrc :"https://www.youtube.com/embed/gTfiNyUNyLU",
        vTitle :"MILLENSYS hospital management software platform" ,
        vHeader :'MiClinic Unified eHealth' ,
        vContent :'Achieve operational excellence in healthcare management',
    },
    {   
        id:4,
        productTitle : 'ENTERPRISE IMAGING',
        img_1 : ENTERPRISE_IMAGING,
        img_2 : ENTERPRISE_IMAGING_2,
        title_1 : 'Why Vision Tools Workspace VNA ?',
        sub_title_1 : 'A powerful enterprise imaging management software platform for archiving and viewing and sharing of medical images, reports and files across the healthcare enterprise.',
        content_1 :text_5,

        title_2 : 'Vision Tools Workspace VNA is considered as an ideal single GUI Application for all operators,',
        sub_title_2 : 'radiologists, cardiologists, technicians, clinicians , nurses , home viewing , teleradiology and telemedicine operators.',
        content_2 :text_6,
        links :[
            {link : Worksrpace_VNA_Brochure ,linkName : 'Worksrpace VNA Brochure'},
            {link : VNA_IHE_Integration_Statement ,linkName : 'VNA IHE Integration Statement'},
            {link : DICOM_Conformance_Statement ,linkName : 'DICOM Conformance Statement'},
            {link : Workspace_VNA_Presentation ,linkName : 'Workspace VNA Presentation'},
            {link : RIS_PACS_workflow_Animation ,linkName : 'RIS PACS workflow Animation'},
            {link : RIS_PACS_Workflow_Presentation ,linkName : 'RIS PACS Workflow Presentation'},
        ],
        vSrc :"https://www.youtube.com/embed/rYkvWUSgTv4",
        vTitle :"MILLENSYS Vendor Neutral Archive  &quot;Vision Tools Workspace VNA / PACS&quot;",
        vHeader :'The All-in-one Solution' ,
        vContent :'One Solution for image | report archiving and distribution',
        fContent :`One Solution for image | report archiving and distribution`,
        fTitle : `The All-in-one Solution` ,
        fImg  : workspace,
    },
    {   
        id:5,
        productTitle : 'RADIOLOGY MANAGEMENT',
        img_1 : RADIOLOGY_MANAGEMENT,
        title_1 : 'MIlLENSYS, Unified Radiology Platform',
        sub_title_1 : 'The Only Unified Solution to run a professional radiology or diagnostic imaging department that improve clinical, financial, and operational outcomes aiming to achieve operational excellence.',
        content_1 :"The solution include a top leading radiology information system ( RIS ) , KLAS awarded picture archiving and communication systems ( PACS ) and enterprise imaging vendor neutral archive ( VNA ) solution for cross image and reports sharing plus a powerful enterprise resource planning system ( ERP ) for billing , claims , financial , inventory and human resources management combined all in a single database software platform . The platform is powered by many tools to complete the automation process and ease patients like business intelligence dash boards and mobile application for patients’ engagement, booking of exams and viewing of results",
        vSrc :"https://www.youtube.com/embed/OPB5t0Q17hY",
        vTitle :"MILLENSYS Unified Radiology Management Software Platform" ,
        vHeader :'RADIOLOGY MANAGEMENT',
        vContent :"MILLENSYS Unified Radiology Management Software Platform",
        fContent :"MILLENSYS Unified Radiology Management Software Platform",
        fTitle : `Powerful Radiology Solutions` ,
        fImg  : rad_unifiedrad2021,
    },
    {   
        id:6,
        productTitle : 'LAB MANAGEMENT',
        img_1 : LAB_MANAGEMENT,
        img_2 : LAB_MANAGEMENT_2,
        title_1 : 'Why MiClinic LIS ?',
        sub_title_1 : 'A smart Solution for a total management your laboratory',
        content_1 :text_7,

        title_2 : 'Why MiClinic Lab ?',
        sub_title_2 : 'With MiClinic as a web application, you ease installation, support in the enterprise environment and boost connectivity with any other systems (HIS / EHR / EMR).',
        content_2 :text_8,
        links :[
            {link : MiClinic_Presentation ,linkName : 'MiClinic Presentation'},
            {link : IHE_Integration_Statement ,linkName : 'IHE Integration Statement'},
        ],
        fContent :`Complete Workflow management with only MiClinic LIS`,
        fTitle : `Workflow`,
        fImg  : miclinic_lab_modules,
    },
    {   
        id:7,
        productTitle : 'CARDIOLOGY',
        img_1 : CARDIOLOGY,
        title_1 : 'MIlLENSYS, Unified Cardiology Platform',
        sub_title_1 : 'The Unified Solution to manage a professional cardiology department . An All-in-one solution to schedule patients,',
        content_1 :"manage admission , acquire images from modalities, archive patient studies , handle patient medical reporting , manage billing, claims and inventory items plus a full back-end financial management system including ERP and HR",
        vSrc :"https://www.youtube.com/embed/jqbfmyjLbX0",
        vTitle :"MILLENSYS Unified Cardiology Management Software for Cathlab" ,
        vHeader :'CARDIOLOGY',
        vContent :"MILLENSYS Unified Cardiology Management Software for Cathlab" ,
    },
    {   
        id:8,
        productTitle : 'GASTROENTROLOGY',
        img_1 : GASTROENTROLOGY,
        img_2 : GASTROENTROLOGY_2,
        title_1 : 'Why Vision Tools Endo ?',
        sub_title_1 : "The Endoscopy Workstation of choice.",
        content_1 :text_9,

        title_2 : 'Archive Management',
        sub_title_2 : 'View Dynamic studies with Cine-Loop features for play-back controls. zoom/pan and windowing. spacial filters can be included while playback.',
        content_2 :text_10,
        links :[
            {link : Endo_Brochure ,linkName : 'Endo Brochure'},
            {link : Endo_Non_DICOM_Connectivity ,linkName : 'Endo Non DICOM Connectivity'},
            {link : DICOM_Conformance_Statement_2 ,linkName : 'DICOM Conformance Statement'},
        ],
        vSrc :"https://www.youtube.com/embed/CdIWHR0Ygto",
        vTitle :"MILLENSYS Unified Gastroenterology Management software solution",
        vHeader :"MILLENSYS Unified Gastroenterology Management software solution",
        vContent :"View images in multi-format. Do windowing, zoom/pan, annotations, multiple measurements.",
        fContent :`For Non-DICOM Ultrasound, the best interface will be Video grabbing, by which, the SonoPro workstation aided by a remote keypad can acquire images from the ultrasound modalities one-by-one.`,
        fTitle : `Video Grabbing Interface` ,
        fImg  : conn_video,
    },
    {   
        id:10,
        productTitle : 'DERMATOLOGY',
        img_1 : DERMATOLOGY,
        img_2 : DERMATOLOGY_2,
        title_1 : 'Why MiClinic Derma?',
        sub_title_1 : "A Unified EMR / PACS for dermatologists.",
        content_1 :text_11,
    
        title_2 : 'Why MiClinic EMR ?',
        sub_title_2 : 'With MiClinic Derma EMR as a web application, you ease installation, support in the enterprise environment and boost connectivity with any other systems (HIS / PACS).',
        content_2 :text_12,
        links :[
            {link : MiClinic_Brochure ,linkName : 'MiClinic Brochure'},
            {link : MiClinic_Presentation_2 ,linkName : 'MiClinic Presentation'},
            {link : IHE_Integration_Statement_2 ,linkName : 'IHE Integration Statement'},
            {link : DICOM_Conformance_Statement_3 ,linkName : 'DICOM Conformance Statement'},
        ],
        fContent :`View studies in multi-monitor configuration with automatic/manual hanging-protocols for comparison. \nDo zoom/pan, brightness/ contract, annotations.`,
        fTitle : `MiClinic Derma EMR workflow` ,
        fImg  : miclinic_Derma,
    },
    {   
        id:11,
        productTitle : 'DENTAL IMAGING',
        img_1 : DENTAL_IMAGING,
        img_2 : DENTAL_IMAGING_2,
        title_1 : 'Why MILLENSYS Dental Solution?',
        sub_title_1 : "A Unified EMR / PACS for dentists and dental x-ray modalities.",
        content_1 :text_13,
    
        title_2 : 'Image Management',
        sub_title_2 : 'View studies in multi-monitor configuration with automatic/manual hanging-protocols for comparison.',
        content_2 :text_14,
        links :[
            {link : MiClinic_Brochure ,linkName : 'MiClinic Brochure'},
            {link : MiClinic_Presentation_2 ,linkName : 'MiClinic Presentation'},
            {link : IHE_Integration_Statement_2 ,linkName : 'IHE Integration Statement'},
            {link : DICOM_Conformance_Statement_3 ,linkName : 'DICOM Conformance Statement'},
        ],
        fContent :`It has a seamless Integration with MILLENSYS PACS "Vision Tools Workspace" `,
        fTitle : `MiClinic Derma EMR workflow` ,
        fImg  : miclinic_Derma,
    },
    {   
        id:13,
        productTitle : 'HOME CARE',
        img_1 : HOME_CARE,
        img_2 : Home_Care_2,
        title_1 : 'Why MILLENSYS Home care Software Platform ?',
        sub_title_1 : "The unified platform for delivering and managing care at home",
        content_1 :text_15,
    
        title_2 : 'Home Care Mobile Applications',
        sub_title_2 : 'Using MILLENSYS Health Wallet Mobile Apps',
        content_2 :text_16,
        links :[
            {link : Homecare_Presentation ,linkName : 'Homecare Presentation'},
            {link : eHealth_Brochure ,linkName : 'eHealth Brochure'},
        ],
        vSrc :"https://www.youtube.com/embed/JPcPpI6WyIs",
        vTitle :"MILLENSYS Home HeathCare Software Platform" ,
        vHeader :"MILLENSYS home care solution",
        vContent :"MILLENSYS homecare software is considered as a complete end-to-end solution for healthcare providers to diagnose and treat patients at home.",
    },
    {   
        id:14,
        productTitle : 'TELE MEDICINCE',
        img_1 : TELE_MEDICINCE,
        img_2 : TELE_MEDICINCE_2,
        title_1 : 'Why MILLENSYS Telemedicine ?',
        sub_title_1 : "The unified platform for remote diagnosis and treatment",
        content_1 :text_17,
    
        title_2 : 'TELE MEDICINCE workflow',
        sub_title_2 : 'The workflow starts when patient requests a teleconsultation or virtual examination ',
        content_2 :text_18,
        links :[
            {link : Telemedicine_Presentation ,linkName : 'Telemedicine Presentation'},
            {link : eHealth_Brochure ,linkName : 'eHealth Brochure'},
        ],
        vSrc :"https://www.youtube.com/embed/2bfoX6j7aQA",
        vTitle :"MILLENSYS Telemedicine Software Platform" ,
        vHeader :"Introduction to Telemedicine",
        vContent :"A short presentation on telhealth (Voice is in Arabic Language)",
    },
    {   
        id:15,
        productTitle : 'MOBILE HEALTH',
        img_1 : MOBILE_HEALTH,
        img_2 : MOBILE_HEALTH_2,
        title_1 : 'Why MILLENSYS Health Wallet?',
        sub_title_1 : "An Innovative Mobile Application for patient engagement, telemedicine and virtual hospitals",
        content_1 :text_19,
    
        title_2 : 'Mobile Application',
        sub_title_2 : 'Patients can login with their pre-registered account ,',
        content_2 :text_20,
        links :[
            {link : Product_Presentation ,linkName : 'Product Presentation'},
        ],
        vSrc :"https://www.youtube.com/embed/L0BTKMqyYPw",
        vTitle :"MILLENSYS Health Wallet , Patient Engagement , Telemedicine , Home care Mobile Application",
        vHeader :"MILLENSYS Health Wallet , Patient Engagement , Telemedicine , Home care Mobile Application",
        vContent :"Patients can attach any old prescription or medical reports with their new booking request to help physicians track their medical history and find the best diagnosis to their case so that they can propose the best treatment plan for them.",
        fContent :`Connectivity and workflow`,
        fTitle : `Solution Overview` ,
        fImg  : healthwalletworkflow,
    },
    {   
        id:16,
        productTitle : 'FINANCIAL MANAGEMENT',
        img_1 : FINANCIAL_MANAGEMENT,
        img_2 : FINANCIAL_MANAGEMENT_2,
        title_1 : 'Why MILLENSYS ERP ?',
        sub_title_1 : "Web based Financial Management Solution",
        content_1 :text_21,
    
        title_2 : 'Manage Financials',
        sub_title_2 : 'Control Costs and Manage Revenues',
        content_2 :text_22,
        vSrc :"https://www.youtube.com/embed/hHSlmWqLdZA",
        vTitle :"MILLENSYS ERP , MiERP , Powerful Financial and HR management Software",
        vHeader :"The All-in-one Solution",
        vContent :"One Solution for proper enterprise financial management",
    },
    {   
        id:17,
        productTitle : 'INVENTORY MANAGEMENT',
        img_1 : INVENTORY_MANAGEMENT,
        img_2 : INVENTORY_MANAGEMENT_2,
        title_1 : 'Why MILLENSYS Inventory?',
        sub_title_1 : "Web based Inventory Management Solution",
        content_1 :text_23,
    
        title_2 : 'Supply Chain Management',
        sub_title_2 : 'Never have over stock or shortage !',
        content_2 :text_24,
        links :[
            {link : MiERP_Presentation ,linkName : 'MiERP Presentation'},
        ],
    },
    {   
        id:18,
        productTitle : 'HUMAN CAPITAL MANAGEMENT',
        img_1 : HUMAN_CAPITAL_MANAGEMENT,
        img_2 : HUMAN_CAPITAL_MANAGEMENT_2,
        title_1 : 'Why MILLENSYS HR ?',
        sub_title_1 : "Web based Human Resources Management Solution",
        content_1 :text_25,
    
        title_2 : 'Personnel Management',
        sub_title_2 : 'Manage Workforce',
        content_2 :text_26,

        links :[
            {link : MiERP_Presentation ,linkName : 'Product Presentation'},
            {link : MiERP_HR_Brochure_Arabic ,linkName : 'MiERP | HR Brochure (Arabic)'},
        ],
    },
    {   
        id:19,
        productTitle : 'EHR / HMIS',
        img_1 : EHR_HMIS,
        img_2 : EHR_HMIS_2,
        title_1 : 'Why MiClinic EHR ?',
        sub_title_1 : 'The unified Healthcare Management software platform aka electronic health record for a total management of hospitals and healthcare provider enterprises.',
        content_1 :text_27,

        title_2 : 'MiClinic EHR manages',
        sub_title_2 : 'all transactions of outpatient clinics, in-patient "Bed Management" , operation theater and pharamcy. it has also special modules to handle radiology and laboratory departments .',
        content_2 :text_28,
        links :[
            {link : MiClinic_EHR_Brochure ,linkName : 'MiClinic EHR Brochure'},
            {link : MiClinic_EHR_Presentation ,linkName : 'MiClinic EHR Presentation'},
            {link : IHE_Integration_Statement ,linkName : 'IHE Integration Statement'},
        ],
        vSrc :"https://www.youtube.com/embed/fo5rc8iMcUU",
        vTitle :"MILLENSYS , MiClinic unified hospital management platform ( HMIS / EHR )",
        vHeader :'MiClinic' ,
        vContent :"MILLENSYS , MiClinic unified hospital management platform ( HMIS / EHR )",
        fContent :`Unified management with only MiClinic EHR`,
        fTitle : `MiClinic EHR, Key Modules` ,
        fImg  : miclinic_ehr_modules,
    },
    {   
        id:20,
        productTitle : 'EMR',
        img_1 : EMR,
        img_2 : EMR_2,
        title_1 : 'Why MiClinic EMR ?',
        sub_title_1 : 'The unified Information Management platform for a total management of Clinics and healthcare Providers.',
        content_1 :text_29,

        title_2 : 'Why MiClinic ?',
        sub_title_2 : 'It is a total management solution for the whole polyclinic or medical practice from clinical, front-office billing to financial back-office.',
        content_2 :text_30,
        links :[
            {link : MiClinic_EMR_Brochure ,linkName : 'MiClinic EMR Brochure'},
            {link : MiClinic_EMR_Presentation ,linkName : 'MiClinic EMR Presentation'},
            {link : IHE_Integration_Statement ,linkName : 'IHE Integration Statement'},
        ],
        fContent :`Unified management with only MiClinic EMR`,
        fTitle : `MiClinic EMR, Key Modules` ,
        fImg  : miclinic_emr_en,
    },
    {   
        id:21,
        productTitle : 'RIS',
        img_1 : RIS,
        img_2 : RIS_2,
        title_1 : 'Why MiClinic RIS ?',
        sub_title_1 : 'The ultimate Radiology Information System for a total management of radiology operation.',
        content_1 :text_31,

        title_2 : 'Why MiClinic RIS ?',
        sub_title_2 : 'It has proven record of history and installation base in more than 10 countries',
        content_2 :text_32,
        links :[
            {link : MiClinic_RIS_Brochure ,linkName : 'MiClinic RIS Brochure'},
            {link : MiClinic_RIS_Presentation ,linkName : 'MiClinic RIS Presentation'},
            {link : RIS_PACS_workflow_Animation_2 ,linkName : 'RIS PACS workflow Animation'},
            {link : RIS_PACS_Workflow_Presentation_2 ,linkName : 'RIS PACS Workflow Presentation'},
            {link : IHE_Integration_Statement ,linkName : 'IHE Integration Statement'},
        ],
        fContent :`Complete Workflow management with only MiClinic RIS`,
        fTitle : `Workflow` ,
        fImg  : miris_modules,
    },
    {   
        id:22,
        productTitle : 'LIS',
        img_1 : LIS,
        img_2 : LIS_2,
        title_1 : 'Why MiClinic LIS ?',
        sub_title_1 : 'A smart Solution for a total management your laboratory',
        content_1 :text_33,

        title_2 : 'Why MiClinic Lab ?',
        sub_title_2 : 'With MiClinic as a web application, you ease installation, support in the enterprise environment and boost connectivity with any other systems (HIS / EHR / EMR).',
        content_2 :text_34,
        links :[
            {link : MiClinic_Presentation ,linkName : 'MiClinic Presentation'},
            {link : IHE_Integration_Statement ,linkName : 'IHE Integration Statement'},
        ],
        fContent :`Complete Workflow management with only MiClinic LIS`,
        fTitle : `Workflow` ,
        fImg  : miclinic_lab_modules,
    },
    {   
        id:23,
        productTitle : 'PACS',
        img_1 : PACS,
        img_2 : PACS_2,
        title_1 : 'Why Vision Tools Workspace PACS ?',
        sub_title_1 : 'A powerful enterprise imaging management software platform for archiving and viewing and sharing of medical images, reports and files across the healthcare enterprise.',
        content_1 :text_35,

        title_2 : 'The Workspace PACS',
        sub_title_2 : 'Vision Tools Workspace PACS is considered as an ideal single GUI Application for all operators, radiologists, cardiologists, technicians, clinicians , nurses , home viewing , teleradiology operators.',
        content_2 :text_36,
        links :[
            {link : Worksrpace_PACS_Brochure ,linkName : 'Worksrpace PACS Brochure'},
            {link : PACS_IHE_Integration_Statement ,linkName : 'PACS IHE Integration Statementt'},
            {link : DICOM_Conformance_Statement,linkName : 'DICOM Conformance Statement'},
        ],
        fContent :`One Solution for image | report archiving and distribution`,
        fTitle : `The All-in-one Solution` ,
        fImg  : mi_ws_pacs,
    },
    {   
        id:24,
        productTitle : 'PACS Viewer',
        img_1 : PACS_Viewer,
        img_2 : PACS_Viewer_2,
        title_1 : 'Why Vision Tools MultiView ?',
        sub_title_1 : 'The PACS Workstation of choice',
        content_1 :text_37,

        title_2 : 'Vision Tools MultiView ',
        sub_title_2 : 'Vision Tools MultiView suites almost all of the daily activities of any physician in a low cost of ownership and high content solution that is scalable to any organization.',
        content_2 :text_38,
        links :[
            {link : MultiView_Brochure ,linkName : 'MultiView Brochure'},
            {link : MultiView_Presentation,linkName : 'MultiView Presentation'},
            {link : DICOM_Conformance_Statement,linkName : 'DICOM Conformance Statement'},
        ],
        vSrc :"https://www.youtube.com/embed/NWxZO40rs4A",
        vTitle :"MILLENSYS Vision Tools MultiView 12.6 PACS Workstation",
        vHeader :"PACS Workstation",
        vContent :"MILLENSYS Vision Tools MultiView 12.6 PACS Workstation",
    },
    {   
        id:25,
        productTitle : 'Teleradiology',
        img_1 : Teleradiology,
        img_2 : Teleradiology_2,
        title_1 : 'MILLENSYS Teleradiology Platform?',
        sub_title_1 : 'The Ultimate solution for teleradiology firms and remote diagnosis',
        content_1 :text_39,

        title_2 : 'Smart Teleradiology Operation',
        sub_title_2 : 'STAT cases prioritization , manage turn around time TAT workflow , smart study distribution to radiologists with notification on case arrival , return back reports to hospitals via HL7',
        content_2 :text_40,
        links :[
            {link : Teleradiology_Brochure ,linkName : 'Teleradiology Brochure'},
            {link : Workspace_VNA_PACS_Brochure,linkName : 'Workspace VNA PACS Brochure'},
            {link : MiRIS_RIS_Brochure,linkName : 'MiRIS RIS Brochure'},
        ],
        fContent :`Teleradiology Cloud Connectivity and workflow`,
        fTitle : `Solution Overview` ,
        fImg  : telerad3,
    },
    {   
        id:26,
        productTitle : 'Disc Publisher',
        img_1 : Disc_Publisher,
        img_2 : Disc_Publisher_2,
        title_1 : 'Why MiPublisher ?',
        sub_title_1 : 'A powerful Medical Disc Publisher for healthcare',
        content_1 :text_41,

        title_2 : 'Facts',
        sub_title_2 : 'Easy and fast operation with touch screen, no keyboard or mouse needed.',
        content_2 :text_42,
        links :[
            {link : Brochure ,linkName : 'Brochure'},
            {link : MiPublisher_Pro,linkName : 'MiPublisher Pro'},
            {link : DICOM_Conformance_Statement ,linkName : 'DICOM Conformance Statement'},
        ],
        fContent :`With MiPublisher Pro , both CD creation and Paper printing are in one application`,
        fTitle : `Publish CDs and Print to Papers to one Node` ,
        fImg  : mipublisher_miprint,
    },
    {   
        id:27,
        productTitle : 'DICOM Print',
        img_1 : DICOM_Print,
        img_2 : DICOM_Print_2,
        title_1 : 'Why MiPrint ?',
        sub_title_1 : 'A powerful DICOM to Paper printing software',
        content_1 :text_43,

        title_2 : 'Facts',
        sub_title_2 : 'Silent and automatic operation , no need for any interference from users.',
        content_2 :text_44,
        links :[
            {link : Brochure_2 ,linkName : 'Brochure'},
        ],
    },
    {   
        id:28,
        productTitle : 'Financials',
        img_1 : Financials,
        img_2 : Financials_2,
        title_1 : 'Why MILLENSYS Financials?',
        sub_title_1 : 'Web based Financial Management Solution',
        content_1 :text_45,

        title_2 : 'Manage General Ledger',
        sub_title_2 : 'Enterprise Operation',
        content_2 :text_46,
        links :[
            {link : MiERP_Presentation ,linkName : 'MiERP Presentation'},
        ],
    },
    {   
        id:29,
        productTitle : 'CRM',
        img_1 : CRM,
        img_2 : CRM_2,
        title_1 : 'Why MiCRM ?',
        sub_title_1 : 'Web based Customer Relation Management',
        content_1 :text_47,

        title_2 : 'Sales Force Automation',
        sub_title_2 : 'Close more deals , faster',
        content_2 :text_48,
        links :[
            {link : MiCRM_Brochure ,linkName : 'MiCRM Brochure'},
        ],
    },
    {   
        id:30,
        productTitle : 'Business Intelligence',
        img_1 : Business_Intelligence,
        img_2 : Business_Intelligence_2,
        title_1 : 'Why MILLENSYS Analytics ?',
        sub_title_1 : 'The smart business intelligence tool for better managerial decisions.',
        content_1 :text_49,

        title_2 : 'Why MILLENSYS Analytics ?',
        sub_title_2 : 'Web based dashboard and KPI viewer and analysis tool.',
        content_2 :text_50,
        links :[
            {link : MiAnalytics_Brochure ,linkName : 'MiAnalytics Brochure'},
        ],
        vSrc :"https://www.youtube.com/embed/Jl-kzLCRWaU" ,
        vTitle :"MILLENSYS Analytics",
        vHeader :"Leverage Business Performance" ,
        vContent :'Effective business desicions based on confidant data analysis',
    },
    {   
        id:31,
        productTitle : 'Integration',
        img_1 : Integration,
        img_2 : Integration_2,

        title_1 : 'Why MiBroker ?',
        sub_title_1 : 'A powerful Integration Engine for healthcare',
        content_1 :text_51,

        title_2 : 'Integration Capabilities',
        sub_title_2 : 'Accepts ADT, ORM, ORU and DFT HL7 messages. Supports DICOM Modality Worklist / MPPS messages. Non-HL7 HIS integration with PACS / Modalities.',
        content_2 :text_52,
        links :[
            {link : HL7_Conformance_Statement ,linkName : 'HL7 Conformance Statement'},
            {link : DICOM_Conformance_Statement ,linkName : 'DICOM Conformance Statement'},
            {link : IHE_Integration_Statement ,linkName : 'IHE Integration Statement'},
        ],
    },
    {   
        id:32,
        productTitle : 'DICOM Viewer',
        img_1 : DICOM_Viewer,
        title_1 : 'Why MiViewer ?',
        sub_title_1 : 'Portable DICOM Viewer for medical images',
        content_1 :text_53,
    },
]



export const linkToProduct = (title)=>{
    let ID = (products?.find(a => a.productTitle === title))?.id
    let url = `/products/${ID}`
    return url
}